<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  export interface ConfigMenuBtnProps {
    active?: boolean;
    onChange?: (active: boolean) => void;
    disabled?: boolean;
    class?: string;
  }

  const styles = tv({
    base: 'fc-cc rounded-sm p-1 transition-colors duration-300',
    variants: {
      active: {
        true: 'bg-btn-sec hocus:bg-btn-tert-H',
        false: 'bg-plain hover:bg-btn-sec-H',
      },
      disabled: {
        true: 'opacity-30',
        false: '',
      },
    },
    compoundVariants: [
      {
        disabled: true,
        active: true,
        class: 'bg-btn-sec hocus:bg-btn-sec',
      },
      {
        disabled: true,
        active: false,
        class: 'bg-plain hocus:bg-plain',
      },
    ],
  });
</script>

<script lang="ts">
  import { Icon } from '@/ui/base';

  let props: ConfigMenuBtnProps = $props();
  let active = $state(!!props.active);
  $effect(() => {
    active = !!props.active;
  });
  let cn = $derived(styles({ active, disabled: props.disabled, className: props.class }));
  let handleChange = () => {
    active = !active;
    props.onChange?.(active);
  };
  let label = $derived(active ? 'Konfiguration übernehmen' : 'Konfigurationen öffnen');
</script>

<button class={cn} onclick={handleChange} aria-label={label} disabled={props.disabled}>
  <Icon icon={active ? 'Done' : 'Tune'} class="pointer-events-none" size={5} />
</button>
